import { Outlet } from "react-router-dom";
import Navigation from "../Navigation/Navigation";

export const DefaultLayout = () => {
  return (
    <>
      <Navigation />
      <Outlet />
    </>
  );
};
